(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global = globalThis;
    var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirefc44"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirefc44"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5tH02", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("hYDsp")).css);
$parcel$export(module.exports, "html", () => (parcelRequire("i5DCs")).html);
$parcel$export(module.exports, "LitElement", () => (parcelRequire("9DeQk")).LitElement);
parcelRequire("aSZ8h");
parcelRequire("i5DCs");
parcelRequire("9DeQk");
parcelRequire("3chlS");

});
parcelRegister("aSZ8h", function(module, exports) {

$parcel$export(module.exports, "ReactiveElement", () => $7ece5e2ccb4fd0d9$export$c7c07a37856565d);
$parcel$export(module.exports, "css", () => (parcelRequire("hYDsp")).css);

var $hYDsp = parcelRequire("hYDsp");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $7ece5e2ccb4fd0d9$var$i, defineProperty: $7ece5e2ccb4fd0d9$var$e, getOwnPropertyDescriptor: $7ece5e2ccb4fd0d9$var$h, getOwnPropertyNames: $7ece5e2ccb4fd0d9$var$r, getOwnPropertySymbols: $7ece5e2ccb4fd0d9$var$o, getPrototypeOf: $7ece5e2ccb4fd0d9$var$n } = Object, $7ece5e2ccb4fd0d9$var$a = globalThis, $7ece5e2ccb4fd0d9$var$c = $7ece5e2ccb4fd0d9$var$a.trustedTypes, $7ece5e2ccb4fd0d9$var$l = $7ece5e2ccb4fd0d9$var$c ? $7ece5e2ccb4fd0d9$var$c.emptyScript : "", $7ece5e2ccb4fd0d9$var$p = $7ece5e2ccb4fd0d9$var$a.reactiveElementPolyfillSupport, $7ece5e2ccb4fd0d9$var$d = (t, s)=>t, $7ece5e2ccb4fd0d9$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $7ece5e2ccb4fd0d9$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $7ece5e2ccb4fd0d9$export$53a6892c50694894 = (t, s)=>!$7ece5e2ccb4fd0d9$var$i(t, s), $7ece5e2ccb4fd0d9$var$b = {
    attribute: !0,
    type: String,
    converter: $7ece5e2ccb4fd0d9$export$7312b35fbf521afb,
    reflect: !1,
    useDefault: !1,
    hasChanged: $7ece5e2ccb4fd0d9$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $7ece5e2ccb4fd0d9$var$a.litPropertyMetadata ??= new WeakMap;
class $7ece5e2ccb4fd0d9$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $7ece5e2ccb4fd0d9$var$b) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((s = Object.create(s)).wrapped = !0), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), h = this.getPropertyDescriptor(t, i, s);
            void 0 !== h && $7ece5e2ccb4fd0d9$var$e(this.prototype, t, h);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: r } = $7ece5e2ccb4fd0d9$var$h(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get: e,
            set (s) {
                const h = e?.call(this);
                r?.call(this, s), this.requestUpdate(t, h, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $7ece5e2ccb4fd0d9$var$b;
    }
    static _$Ei() {
        if (this.hasOwnProperty($7ece5e2ccb4fd0d9$var$d("elementProperties"))) return;
        const t = $7ece5e2ccb4fd0d9$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($7ece5e2ccb4fd0d9$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($7ece5e2ccb4fd0d9$var$d("properties"))) {
            const t = this.properties, s = [
                ...$7ece5e2ccb4fd0d9$var$r(t),
                ...$7ece5e2ccb4fd0d9$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $hYDsp.getCompatibleStyle)(s));
        } else void 0 !== s && i.push((0, $hYDsp.getCompatibleStyle)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $hYDsp.adoptStyles)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$ET(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const h = (void 0 !== i.converter?.toAttribute ? i.converter : $7ece5e2ccb4fd0d9$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == h ? this.removeAttribute(e) : this.setAttribute(e, h), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $7ece5e2ccb4fd0d9$export$7312b35fbf521afb;
            this._$Em = e;
            const r = h.fromAttribute(s, t.type);
            this[e] = r ?? this._$Ej?.get(e) ?? r, this._$Em = null;
        }
    }
    requestUpdate(t, s, i, e = !1, h) {
        if (void 0 !== t) {
            const r = this.constructor;
            if (!1 === e && (h = this[t]), i ??= r.getPropertyOptions(t), !((i.hasChanged ?? $7ece5e2ccb4fd0d9$export$53a6892c50694894)(h, s) || i.useDefault && i.reflect && h === this._$Ej?.get(t) && !this.hasAttribute(r._$Eu(t, i)))) return;
            this.C(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$EP());
    }
    C(t, s, { useDefault: i, reflect: e, wrapped: h }, r) {
        i && !(this._$Ej ??= new Map).has(t) && (this._$Ej.set(t, r ?? s ?? this[t]), !0 !== h || void 0 !== r) || (this._$AL.has(t) || (this.hasUpdated || i || (s = void 0), this._$AL.set(t, s)), !0 === e && this._$Em !== t && (this._$Eq ??= new Set).add(t));
    }
    async _$EP() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t){
                const { wrapped: t } = i, e = this[s];
                !0 !== t || this._$AL.has(s) || void 0 === e || this.C(s, void 0, i, e);
            }
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EM();
        } catch (s) {
            throw t = !1, this._$EM(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EM() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Eq &&= this._$Eq.forEach((t)=>this._$ET(t, this[t])), this._$EM();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$7ece5e2ccb4fd0d9$export$c7c07a37856565d.elementStyles = [], $7ece5e2ccb4fd0d9$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $7ece5e2ccb4fd0d9$export$c7c07a37856565d[$7ece5e2ccb4fd0d9$var$d("elementProperties")] = new Map, $7ece5e2ccb4fd0d9$export$c7c07a37856565d[$7ece5e2ccb4fd0d9$var$d("finalized")] = new Map, $7ece5e2ccb4fd0d9$var$p?.({
    ReactiveElement: $7ece5e2ccb4fd0d9$export$c7c07a37856565d
}), ($7ece5e2ccb4fd0d9$var$a.reactiveElementVersions ??= []).push("2.1.2");

});
parcelRegister("hYDsp", function(module, exports) {

$parcel$export(module.exports, "css", () => $d166a5a387251cdc$export$dbf350e5966cf602);
$parcel$export(module.exports, "adoptStyles", () => $d166a5a387251cdc$export$2ca4a66ec4cecb90);
$parcel$export(module.exports, "getCompatibleStyle", () => $d166a5a387251cdc$export$ee69dfd951e24778);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $d166a5a387251cdc$var$t = globalThis, $d166a5a387251cdc$export$b4d10f6001c083c2 = $d166a5a387251cdc$var$t.ShadowRoot && (void 0 === $d166a5a387251cdc$var$t.ShadyCSS || $d166a5a387251cdc$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $d166a5a387251cdc$var$s = Symbol(), $d166a5a387251cdc$var$o = new WeakMap;
class $d166a5a387251cdc$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $d166a5a387251cdc$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($d166a5a387251cdc$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $d166a5a387251cdc$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $d166a5a387251cdc$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $d166a5a387251cdc$export$8d80f9cac07cdb3 = (t)=>new $d166a5a387251cdc$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $d166a5a387251cdc$var$s), $d166a5a387251cdc$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $d166a5a387251cdc$export$505d1e8739bad805(o, t, $d166a5a387251cdc$var$s);
}, $d166a5a387251cdc$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($d166a5a387251cdc$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $d166a5a387251cdc$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $d166a5a387251cdc$export$ee69dfd951e24778 = $d166a5a387251cdc$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $d166a5a387251cdc$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("i5DCs", function(module, exports) {

$parcel$export(module.exports, "html", () => $d2b76d366be0d5ac$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "noChange", () => $d2b76d366be0d5ac$export$9c068ae9cc5db4e8);
$parcel$export(module.exports, "render", () => $d2b76d366be0d5ac$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $d2b76d366be0d5ac$var$t = globalThis, $d2b76d366be0d5ac$var$i = (t)=>t, $d2b76d366be0d5ac$var$s = $d2b76d366be0d5ac$var$t.trustedTypes, $d2b76d366be0d5ac$var$e = $d2b76d366be0d5ac$var$s ? $d2b76d366be0d5ac$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $d2b76d366be0d5ac$var$h = "$lit$", $d2b76d366be0d5ac$var$o = `lit$${Math.random().toFixed(9).slice(2)}$`, $d2b76d366be0d5ac$var$n = "?" + $d2b76d366be0d5ac$var$o, $d2b76d366be0d5ac$var$r = `<${$d2b76d366be0d5ac$var$n}>`, $d2b76d366be0d5ac$var$l = document, $d2b76d366be0d5ac$var$c = ()=>$d2b76d366be0d5ac$var$l.createComment(""), $d2b76d366be0d5ac$var$a = (t)=>null === t || "object" != typeof t && "function" != typeof t, $d2b76d366be0d5ac$var$u = Array.isArray, $d2b76d366be0d5ac$var$d = (t)=>$d2b76d366be0d5ac$var$u(t) || "function" == typeof t?.[Symbol.iterator], $d2b76d366be0d5ac$var$f = "[ \t\n\f\r]", $d2b76d366be0d5ac$var$v = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $d2b76d366be0d5ac$var$_ = /-->/g, $d2b76d366be0d5ac$var$m = />/g, $d2b76d366be0d5ac$var$p = RegExp(`>|${$d2b76d366be0d5ac$var$f}(?:([^\\s"'>=/]+)(${$d2b76d366be0d5ac$var$f}*=${$d2b76d366be0d5ac$var$f}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $d2b76d366be0d5ac$var$g = /'/g, $d2b76d366be0d5ac$var$$ = /"/g, $d2b76d366be0d5ac$var$y = /^(?:script|style|textarea|title)$/i, $d2b76d366be0d5ac$var$x = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $d2b76d366be0d5ac$export$c0bb0b647f701bb5 = $d2b76d366be0d5ac$var$x(1), $d2b76d366be0d5ac$export$7ed1367e7fa1ad68 = $d2b76d366be0d5ac$var$x(2), $d2b76d366be0d5ac$export$47d5b44d225be5b4 = $d2b76d366be0d5ac$var$x(3), $d2b76d366be0d5ac$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $d2b76d366be0d5ac$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $d2b76d366be0d5ac$var$C = new WeakMap, $d2b76d366be0d5ac$var$P = $d2b76d366be0d5ac$var$l.createTreeWalker($d2b76d366be0d5ac$var$l, 129);
function $d2b76d366be0d5ac$var$V(t, i) {
    if (!$d2b76d366be0d5ac$var$u(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $d2b76d366be0d5ac$var$e ? $d2b76d366be0d5ac$var$e.createHTML(i) : i;
}
const $d2b76d366be0d5ac$var$N = (t, i)=>{
    const s = t.length - 1, e = [];
    let n, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $d2b76d366be0d5ac$var$v;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, f = 0;
        for(; f < s.length && (c.lastIndex = f, u = c.exec(s), null !== u);)f = c.lastIndex, c === $d2b76d366be0d5ac$var$v ? "!--" === u[1] ? c = $d2b76d366be0d5ac$var$_ : void 0 !== u[1] ? c = $d2b76d366be0d5ac$var$m : void 0 !== u[2] ? ($d2b76d366be0d5ac$var$y.test(u[2]) && (n = RegExp("</" + u[2], "g")), c = $d2b76d366be0d5ac$var$p) : void 0 !== u[3] && (c = $d2b76d366be0d5ac$var$p) : c === $d2b76d366be0d5ac$var$p ? ">" === u[0] ? (c = n ?? $d2b76d366be0d5ac$var$v, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $d2b76d366be0d5ac$var$p : '"' === u[3] ? $d2b76d366be0d5ac$var$$ : $d2b76d366be0d5ac$var$g) : c === $d2b76d366be0d5ac$var$$ || c === $d2b76d366be0d5ac$var$g ? c = $d2b76d366be0d5ac$var$p : c === $d2b76d366be0d5ac$var$_ || c === $d2b76d366be0d5ac$var$m ? c = $d2b76d366be0d5ac$var$v : (c = $d2b76d366be0d5ac$var$p, n = void 0);
        const x = c === $d2b76d366be0d5ac$var$p && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $d2b76d366be0d5ac$var$v ? s + $d2b76d366be0d5ac$var$r : d >= 0 ? (e.push(a), s.slice(0, d) + $d2b76d366be0d5ac$var$h + s.slice(d) + $d2b76d366be0d5ac$var$o + x) : s + $d2b76d366be0d5ac$var$o + (-2 === d ? i : x);
    }
    return [
        $d2b76d366be0d5ac$var$V(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        e
    ];
};
class $d2b76d366be0d5ac$var$S {
    constructor({ strings: t, _$litType$: i }, e){
        let r;
        this.parts = [];
        let l = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $d2b76d366be0d5ac$var$N(t, i);
        if (this.el = $d2b76d366be0d5ac$var$S.createElement(f, e), $d2b76d366be0d5ac$var$P.currentNode = this.el.content, 2 === i || 3 === i) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $d2b76d366be0d5ac$var$P.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($d2b76d366be0d5ac$var$h)) {
                    const i = v[a++], s = r.getAttribute(t).split($d2b76d366be0d5ac$var$o), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: l,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $d2b76d366be0d5ac$var$I : "?" === e[1] ? $d2b76d366be0d5ac$var$L : "@" === e[1] ? $d2b76d366be0d5ac$var$z : $d2b76d366be0d5ac$var$H
                    }), r.removeAttribute(t);
                } else t.startsWith($d2b76d366be0d5ac$var$o) && (d.push({
                    type: 6,
                    index: l
                }), r.removeAttribute(t));
                if ($d2b76d366be0d5ac$var$y.test(r.tagName)) {
                    const t = r.textContent.split($d2b76d366be0d5ac$var$o), i = t.length - 1;
                    if (i > 0) {
                        r.textContent = $d2b76d366be0d5ac$var$s ? $d2b76d366be0d5ac$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)r.append(t[s], $d2b76d366be0d5ac$var$c()), $d2b76d366be0d5ac$var$P.nextNode(), d.push({
                            type: 2,
                            index: ++l
                        });
                        r.append(t[i], $d2b76d366be0d5ac$var$c());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $d2b76d366be0d5ac$var$n) d.push({
                    type: 2,
                    index: l
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($d2b76d366be0d5ac$var$o, t + 1));)d.push({
                        type: 7,
                        index: l
                    }), t += $d2b76d366be0d5ac$var$o.length - 1;
                }
            }
            l++;
        }
    }
    static createElement(t, i) {
        const s = $d2b76d366be0d5ac$var$l.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $d2b76d366be0d5ac$var$M(t, i, s = t, e) {
    if (i === $d2b76d366be0d5ac$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $d2b76d366be0d5ac$var$a(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $d2b76d366be0d5ac$var$M(t, h._$AS(t, i.values), h, e)), i;
}
class $d2b76d366be0d5ac$var$R {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $d2b76d366be0d5ac$var$l).importNode(i, !0);
        $d2b76d366be0d5ac$var$P.currentNode = e;
        let h = $d2b76d366be0d5ac$var$P.nextNode(), o = 0, n = 0, r = s[0];
        for(; void 0 !== r;){
            if (o === r.index) {
                let i;
                2 === r.type ? i = new $d2b76d366be0d5ac$var$k(h, h.nextSibling, this, t) : 1 === r.type ? i = new r.ctor(h, r.name, r.strings, this, t) : 6 === r.type && (i = new $d2b76d366be0d5ac$var$Z(h, this, t)), this._$AV.push(i), r = s[++n];
            }
            o !== r?.index && (h = $d2b76d366be0d5ac$var$P.nextNode(), o++);
        }
        return $d2b76d366be0d5ac$var$P.currentNode = $d2b76d366be0d5ac$var$l, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $d2b76d366be0d5ac$var$k {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $d2b76d366be0d5ac$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $d2b76d366be0d5ac$var$M(this, t, i), $d2b76d366be0d5ac$var$a(t) ? t === $d2b76d366be0d5ac$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $d2b76d366be0d5ac$export$45b790e32b2810ee && this._$AR(), this._$AH = $d2b76d366be0d5ac$export$45b790e32b2810ee) : t !== this._$AH && t !== $d2b76d366be0d5ac$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $d2b76d366be0d5ac$var$d(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $d2b76d366be0d5ac$export$45b790e32b2810ee && $d2b76d366be0d5ac$var$a(this._$AH) ? this._$AA.nextSibling.data = t : this.T($d2b76d366be0d5ac$var$l.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $d2b76d366be0d5ac$var$S.createElement($d2b76d366be0d5ac$var$V(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $d2b76d366be0d5ac$var$R(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $d2b76d366be0d5ac$var$C.get(t.strings);
        return void 0 === i && $d2b76d366be0d5ac$var$C.set(t.strings, i = new $d2b76d366be0d5ac$var$S(t)), i;
    }
    k(t) {
        $d2b76d366be0d5ac$var$u(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $d2b76d366be0d5ac$var$k(this.O($d2b76d366be0d5ac$var$c()), this.O($d2b76d366be0d5ac$var$c()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, s) {
        for(this._$AP?.(!1, !0, s); t !== this._$AB;){
            const s = $d2b76d366be0d5ac$var$i(t).nextSibling;
            $d2b76d366be0d5ac$var$i(t).remove(), t = s;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $d2b76d366be0d5ac$var$H {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $d2b76d366be0d5ac$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $d2b76d366be0d5ac$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $d2b76d366be0d5ac$var$M(this, t, i, 0), o = !$d2b76d366be0d5ac$var$a(t) || t !== this._$AH && t !== $d2b76d366be0d5ac$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $d2b76d366be0d5ac$var$M(this, e[s + n], i, n), r === $d2b76d366be0d5ac$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$d2b76d366be0d5ac$var$a(r) || r !== this._$AH[n], r === $d2b76d366be0d5ac$export$45b790e32b2810ee ? t = $d2b76d366be0d5ac$export$45b790e32b2810ee : t !== $d2b76d366be0d5ac$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $d2b76d366be0d5ac$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $d2b76d366be0d5ac$var$I extends $d2b76d366be0d5ac$var$H {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $d2b76d366be0d5ac$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $d2b76d366be0d5ac$var$L extends $d2b76d366be0d5ac$var$H {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $d2b76d366be0d5ac$export$45b790e32b2810ee);
    }
}
class $d2b76d366be0d5ac$var$z extends $d2b76d366be0d5ac$var$H {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $d2b76d366be0d5ac$var$M(this, t, i, 0) ?? $d2b76d366be0d5ac$export$45b790e32b2810ee) === $d2b76d366be0d5ac$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $d2b76d366be0d5ac$export$45b790e32b2810ee && s !== $d2b76d366be0d5ac$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $d2b76d366be0d5ac$export$45b790e32b2810ee && (s === $d2b76d366be0d5ac$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $d2b76d366be0d5ac$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $d2b76d366be0d5ac$var$M(this, t);
    }
}
const $d2b76d366be0d5ac$export$8613d1ca9052b22e = {
    M: $d2b76d366be0d5ac$var$h,
    P: $d2b76d366be0d5ac$var$o,
    A: $d2b76d366be0d5ac$var$n,
    C: 1,
    L: $d2b76d366be0d5ac$var$N,
    R: $d2b76d366be0d5ac$var$R,
    D: $d2b76d366be0d5ac$var$d,
    V: $d2b76d366be0d5ac$var$M,
    I: $d2b76d366be0d5ac$var$k,
    H: $d2b76d366be0d5ac$var$H,
    N: $d2b76d366be0d5ac$var$L,
    U: $d2b76d366be0d5ac$var$z,
    B: $d2b76d366be0d5ac$var$I,
    F: $d2b76d366be0d5ac$var$Z
}, $d2b76d366be0d5ac$var$B = $d2b76d366be0d5ac$var$t.litHtmlPolyfillSupport;
$d2b76d366be0d5ac$var$B?.($d2b76d366be0d5ac$var$S, $d2b76d366be0d5ac$var$k), ($d2b76d366be0d5ac$var$t.litHtmlVersions ??= []).push("3.3.2");
const $d2b76d366be0d5ac$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $d2b76d366be0d5ac$var$k(i.insertBefore($d2b76d366be0d5ac$var$c(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};

});

parcelRegister("9DeQk", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("hYDsp")).css);
$parcel$export(module.exports, "ReactiveElement", () => (parcelRequire("aSZ8h")).ReactiveElement);
$parcel$export(module.exports, "html", () => (parcelRequire("i5DCs")).html);
$parcel$export(module.exports, "noChange", () => (parcelRequire("i5DCs")).noChange);
$parcel$export(module.exports, "render", () => (parcelRequire("i5DCs")).render);

$parcel$export(module.exports, "LitElement", () => $70334511cd44bfe1$export$3f2f9f5909897157);

var $aSZ8h = parcelRequire("aSZ8h");

var $i5DCs = parcelRequire("i5DCs");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $70334511cd44bfe1$var$s = globalThis;
class $70334511cd44bfe1$export$3f2f9f5909897157 extends (0, $aSZ8h.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const r = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $i5DCs.render)(r, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $i5DCs.noChange;
    }
}
$70334511cd44bfe1$export$3f2f9f5909897157._$litElement$ = !0, $70334511cd44bfe1$export$3f2f9f5909897157["finalized"] = !0, $70334511cd44bfe1$var$s.litElementHydrateSupport?.({
    LitElement: $70334511cd44bfe1$export$3f2f9f5909897157
});
const $70334511cd44bfe1$var$o = $70334511cd44bfe1$var$s.litElementPolyfillSupport;
$70334511cd44bfe1$var$o?.({
    LitElement: $70334511cd44bfe1$export$3f2f9f5909897157
});
const $70334511cd44bfe1$export$f5c524615a7708d6 = {
    _$AK: (t, e, r)=>{
        t._$AK(e, r);
    },
    _$AL: (t)=>t._$AL
};
($70334511cd44bfe1$var$s.litElementVersions ??= []).push("4.2.2");

});

parcelRegister("3chlS", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $253ff3cbfdeb982b$export$6acf61af03e62db = !1;

});


parcelRegister("8F9wt", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("iyWWF")).then(()=>parcelRequire('iP0Ys'));

});
parcelRegister("dNLwc", function(module, exports) {
"use strict";

var $7lV8K = parcelRequire("7lV8K");
module.exports = $7lV8K(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("7lV8K", function(module, exports) {
"use strict";
var $55a6d16921f8ab25$var$cachedBundles = {};
var $55a6d16921f8ab25$var$cachedPreloads = {};
var $55a6d16921f8ab25$var$cachedPrefetches = {};
function $55a6d16921f8ab25$var$getCache(type) {
    switch(type){
        case 'preload':
            return $55a6d16921f8ab25$var$cachedPreloads;
        case 'prefetch':
            return $55a6d16921f8ab25$var$cachedPrefetches;
        default:
            return $55a6d16921f8ab25$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $55a6d16921f8ab25$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("dAsxU", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("jJHbj")).then(()=>parcelRequire('5N0lk'));

});

parcelRegister("i95AM", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("22paI")).then(()=>parcelRequire('9EWit'));

});

parcelRegister("fpNBn", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("c6aV5")).then(()=>parcelRequire('exQkD'));

});

parcelRegister("620k0", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("758MJ")).then(()=>parcelRequire('95PXg'));

});

parcelRegister("boJGw", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("bNUXZ")).then(()=>parcelRequire('iOaa8'));

});

parcelRegister("8kOi1", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("7yXg2")).then(()=>parcelRequire('fbc7G'));

});

parcelRegister("l65wZ", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("lPxQ7")).then(()=>parcelRequire('68p6p'));

});

parcelRegister("2kfVN", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("hWcEM")).then(()=>parcelRequire('96dsE'));

});

parcelRegister("5gmVR", function(module, exports) {

module.exports = (parcelRequire("dNLwc"))($parcel$resolve("lW1TV")).then(()=>parcelRequire('1sBZt'));

});

var $92f45997de0f1869$exports = {};
$parcel$extendImportMap({
    "iyWWF": "showFirstEvent.ad6b51b7.js",
    "jJHbj": "pdfViewer.4a30643c.js",
    "22paI": "pdfUtils.0c6735aa.js",
    "c6aV5": "jobComponent.66e7d011.js",
    "758MJ": "partnerComponent.e5a31c97.js",
    "bNUXZ": "eventComponent.7370e4bc.js",
    "7yXg2": "adminLoginComponent.11b54782.js",
    "lPxQ7": "userDataComponent.0df3ccea.js",
    "hWcEM": "pdfDataComponent.58fb10ba.js",
    "lW1TV": "gdprDataComponent.688d8375.js"
});

/**
 * @file index.js
 * @description Frontend entrypoint that registers all custom elements.
 */ // used everywhere
/**
 * @file trackerPopupComponent.js
 * @description Cookie/analytics consent popup web component.
 */ /*
* Behavior now works like this: first visit gets no tracking snippet by default;
* the popup submits Accept/Reject with CSRF protection, stores the local
* sessionStorage flags, records the audit row, and sets the signed consent cookie.
* On later navigations, granted consent causes the server to inject GA again,
* while denied or unset consent keeps it excluded. New tabs can now bootstrap from
* the server consent-state endpoint even though sessionStorage is tab-local, and
* granted consent is also passed into GA init via server-rendered script metadata
* so cross-tab granted state does not fall back to denied in
* public/js/ga4-init.js.
*/ parcelRequire("5tH02");
var $hYDsp = parcelRequire("hYDsp");
var $i5DCs = parcelRequire("i5DCs");
var $9DeQk = parcelRequire("9DeQk");
class $e2f43398fdd1b157$export$2e2bcd8739ae039 extends (0, $9DeQk.LitElement) {
    constructor(){
        super();
        this.popupIsHidden = true;
        this.isSubmitting = false;
        this.csrfToken = null;
    }
    static get properties() {
        return {
            popupIsHidden: {
                type: Boolean,
                attribute: false
            },
            isSubmitting: {
                type: Boolean,
                attribute: false
            }
        };
    }
    static get styles() {
        return (0, $hYDsp.css)`
      :host {
        display: block;
        align-items: center;
        justify-content: center;
        width: 40vw;
        position: fixed;
        bottom: 2rem;
        left: 2rem;
        height: max-content;
        z-index: 5000;
        background-color: #005B99;
        color: #fff;
        filter: drop-shadow(0 0 0.3rem black);
      }

      button {
        width: max-content;
      }

      .tracker__action-bar {
        width: max-content;
        margin: 0 2rem 0 auto;
      }

      .link--on-color{
        color: white;
        text-decoration: underline;
      }

      .link--on-color:hover {
        color: var(--color-blue);
      }

      @media only screen and (max-width: 900px) {
        :host {
          width: 50vw;
          left: 0;
        }
      }

      @media only screen and (max-width: 500px) {
        :host {
          width: 100vw;
          left: 0;
        }
      }
    `;
    }
    /**
   * Renders popup content unless hidden by session state.
   *
   * @returns {import('lit').TemplateResult}
   */ render() {
        return this.popupIsHidden ? (0, $i5DCs.html)`` : (0, $i5DCs.html)`
    <link rel="stylesheet" href="/index.css" />
    <p class="content">
      We use analytics to enhance user experience and to analyze performance
      and traffic on our website. We also share information about your use of
      our site with our social media, advertising and analytics partners. For more information, please see our:
      <a href="/privacy-policy" target="_blank" rel="noopener" class="link--on-color">Privacy Policy</a>
    </p>
    <div class="tracker__action-bar">
      <button ?disabled="${this.isSubmitting}" @click="${this.handleRejectCookiesClick}" class="button__ghost--on-color">
        Reject
      </button>
      <button ?disabled="${this.isSubmitting}" @click="${this.handleAcceptClick}" class="button__primary">Accept</button>
    </div>`;
    }
    /**
   * Initializes popup visibility based on prior session choice.
   *
   * @returns {void}
   */ connectedCallback() {
        super.connectedCallback();
        // const storedValue = sessionStorage.getItem("popup-hidden");
        // if (storedValue && storedValue !== null)
        //   if (storedValue === "true") {
        //     this.popupIsHidden = true;
        //     return;
        //   }
        this.initializeConsentState();
    }
    async initializeConsentState() {
        try {
            const response = await fetch('/api/v1/privacy-log/consent-state');
            if (!response.ok) {
                this.popupIsHidden = false;
                return;
            }
            const data = await response.json();
            if (data?.decision === 'granted' || data?.decision === 'denied') {
                this.persistLocalConsent(data.decision);
                this.popupIsHidden = true;
                this.updateClientConsent(data.decision);
                return;
            }
        } catch (error) {
            console.error('Failed to initialize consent state:', error);
        }
        this.popupIsHidden = false;
    }
    persistLocalConsent(decision) {
        sessionStorage.setItem('popup-hidden', true);
        sessionStorage.setItem('ga4-consent', decision);
    }
    updateClientConsent(decision) {
        if (typeof window.gtag !== 'function') return;
        const consentValue = decision === 'granted' ? 'granted' : 'denied';
        window.gtag('consent', 'update', {
            ad_storage: consentValue,
            analytics_storage: consentValue
        });
    }
    async fetchCsrfToken() {
        if (window.csrfTokenPromise) {
            this.csrfToken = await window.csrfTokenPromise;
            return;
        }
        if (window.sharedCsrfToken && window.sharedCsrfTokenTimestamp && Date.now() - window.sharedCsrfTokenTimestamp < 300000) {
            this.csrfToken = window.sharedCsrfToken;
            return;
        }
        window.csrfTokenPromise = (async ()=>{
            const response = await fetch('/api/csrf-token');
            const data = await response.json();
            window.sharedCsrfToken = data.csrfToken;
            window.sharedCsrfTokenTimestamp = Date.now();
            window.csrfTokenPromise = null;
            return data.csrfToken;
        })();
        try {
            this.csrfToken = await window.csrfTokenPromise;
        } catch (error) {
            window.csrfTokenPromise = null;
            throw error;
        }
    }
    async getBrowserSignature() {
        const parts = [
            navigator.userAgent || '',
            navigator.language || '',
            navigator.platform || '',
            Intl.DateTimeFormat().resolvedOptions().timeZone || '',
            `${screen.width}x${screen.height}x${screen.colorDepth}`
        ];
        const payload = new TextEncoder().encode(parts.join('|'));
        const digest = await crypto.subtle.digest('SHA-256', payload);
        return Array.from(new Uint8Array(digest)).map((value)=>value.toString(16).padStart(2, '0')).join('');
    }
    async submitConsentDecision(decision) {
        await this.fetchCsrfToken();
        const browserSignature = await this.getBrowserSignature();
        const response = await fetch('/api/v1/privacy-log', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': this.csrfToken
            },
            body: JSON.stringify({
                decision: decision,
                browserSignature: browserSignature
            })
        });
        if (!response.ok) throw new Error(`Consent submission failed with status ${response.status}`);
    }
    async handleConsentDecision(decision) {
        if (this.isSubmitting) return;
        this.isSubmitting = true;
        try {
            await this.submitConsentDecision(decision);
            this.persistLocalConsent(decision);
            this.updateClientConsent(decision);
            this.popupIsHidden = true;
        } catch (error) {
            console.error('Failed to record consent decision:', error);
            this.popupIsHidden = false;
        } finally{
            this.isSubmitting = false;
        }
    }
    /**
   * Accepts analytics consent and stores session flags.
   *
   * @returns {void}
   */ handleAcceptClick() {
        this.handleConsentDecision('granted');
    }
    /**
   * Rejects analytics consent and stores session flags.
   *
   * @returns {void}
   */ handleRejectCookiesClick() {
        this.handleConsentDecision('denied');
    }
}
customElements.define("tracker-popup", $e2f43398fdd1b157$export$2e2bcd8739ae039);


const $d1ede43de03c5b3d$var$path = window.location.pathname;












switch($d1ede43de03c5b3d$var$path){
    case "/":
        (parcelRequire("8F9wt"));
        break;
    case "/software":
        (parcelRequire("dAsxU"));
        (parcelRequire("i95AM"));
        break;
    case "/careers":
        (parcelRequire("fpNBn"));
        break;
    case "/partners":
        (parcelRequire("620k0"));
        break;
    case "/events":
        (parcelRequire("boJGw"));
        break;
    case "/admin":
        (parcelRequire("fpNBn"));
        (parcelRequire("boJGw"));
        (parcelRequire("8kOi1"));
        (parcelRequire("l65wZ"));
        (parcelRequire("2kfVN"));
        (parcelRequire("5gmVR"));
        break;
}
//utils
function $d1ede43de03c5b3d$var$styleCurrentPageLink() {
    const links = document.querySelectorAll("li");
    Array.from(links).forEach((li)=>{
        const link = li.querySelector("a");
        if (link && link.pathname === window.location.pathname) li.classList.add("active");
    });
}
function $d1ede43de03c5b3d$var$setYear() {
    const year = document.getElementById("year");
    year.textContent = new Date().getFullYear();
}
$d1ede43de03c5b3d$var$styleCurrentPageLink();
$d1ede43de03c5b3d$var$setYear();

})();
//# sourceMappingURL=index.js.map
